export default __webpack_public_path__ + "static/Suavitel-b697cd2e4ceb5714e2ba9fa41d1fd808.png";